import { Box, Typography } from "@mui/material";
import CSS from 'csstype';

export const NavBar = () => {

  const NavBarStyle: CSS.Properties = {
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'end',
    padding: '20px 44px',
    backgroundColor: 'white',
  }

  const TextStyle: CSS.Properties = {
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '10px',
  }

  return (
    <Box style={NavBarStyle} sx={{
      "@media screen and (max-width: 900px)": {
        padding: '20px',
      }
    }}>
      <img src={'/images/MIT-Icon.png'} alt="MIT logo" style={{filter: 'brightness(0%)'}}
        width={51} height={27}/>
      <Typography variant="body1" style={TextStyle}>Commencement {new Date().getFullYear()}</Typography>
    </Box>
  )
}
